import classNames from 'classnames';
import { capitalize, lowerCase } from 'lodash';
import { Select } from 'ui';

export interface SelectWithEnumProps<T> {
  isClearable?: boolean;
  label?: string;
  placeholder?: string;
  className?: string;
  handleChange: (option: T | null) => void;
  value?: T;
  enumValue: object;
}

export const SelectWithEnum = <T,>({
  isClearable,
  label = '',
  placeholder,
  className,
  value,
  handleChange,
  enumValue,
}: SelectWithEnumProps<T>) => {
  return (
    <div
      className={classNames(
        'flex items-center border px-2 rounded-lg gap-2 w-full font-[Inter] text-sm leading-[22px]',
        {
          'min-w-[280px]': !className?.includes('min-w-'),
          'max-w-[350px]': !className?.includes('max-w-'),
        },
        className,
      )}
    >
      {label && (
        <span className="border-r pr-2 w-1/2 h-[40px] text-center flex items-center justify-start text-gray-600">
          {label}
        </span>
      )}
      <span className="pl-2 w-full">
        <Select
          isClearable={isClearable}
          placeholder={placeholder}
          value={value}
          options={Object.values(enumValue).map((value: T) => ({
            value: value,
            label: capitalize(lowerCase(value as string)),
          }))}
          onChange={handleChange}
          showBorderBottom={false}
        />
      </span>
    </div>
  );
};
